import { render, staticRenderFns } from "./ViewITCRDetails.vue?vue&type=template&id=26ed0506"
import script from "./ViewITCRDetails.vue?vue&type=script&lang=js"
export * from "./ViewITCRDetails.vue?vue&type=script&lang=js"
import style0 from "./ViewITCRDetails.vue?vue&type=style&index=0&id=26ed0506&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports